import Dialog from "@/components/Dialog";
import { t } from "@/utils";

export default function CameraOfflineDialog({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("cameraNotAvailable")}
      buttons={{
        cancel: { label: t("buttons.ok") }
      }}
      body={t("cameraNotAvailable.detectionZone.explanation")}
    />
  );
}
